import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import moment from "moment";
import React from "react";
import { styles } from "..";

const UCAF = ({ printData, printedName }) => {
  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));
  const patinetInfo = printData?.patient;

  const coveragePersonal = printData?.coverage_info;
  const payerPersonal = printData?.payer_response;
  const visitTimeDate = moment(payerPersonal?.requestat).format(
    "DD-MM-YYYY , hh:MM A"
  );
  return (
    <Document>
      <Page size="A3" style={styles.page}>
        <Text style={styles.heading}>ucaf 2.0</Text>
        <View style={styles.flexRow}>
          <View style={styles.cardStyle}>
            <Text style={styles.title}>
              To be completed & ID verified by the reception/nurse:
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Provider Name: </Text>
              <Text style={styles.s1textvalue}>
                {selectedBranch?.branch_name || "-"}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Insurance Company Name: </Text>
              <Text style={styles.s1textvalue}>
                {printData?.insurance_name || "-"}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>TPA Company Name: </Text>
              <Text style={styles.s1textvalue}>{"-"}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Patient File Number: </Text>
              <Text style={styles.s1textvalue}>{patinetInfo?.patient_mrn}</Text>
            </Text>
            <View style={styles.flexRow}>
              <Text style={styles.checkItem}>
                Single {"(  "}
                {")"}
              </Text>
              <Text style={styles.checkItem}>
                Married {"(  "}
                {")"}
              </Text>
              <Text style={styles.checkItem}>
                Plan Type {"(  "}
                {")"}
              </Text>
            </View>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Date of visit: </Text>
              <Text style={styles.s1textvalue}>{visitTimeDate}</Text>
            </Text>
            <View style={styles.flexRow}>
              <Text style={styles.checkItem}>
                New visit {"(  "}
                {")"}
              </Text>
              <Text style={styles.checkItem}>
                Follow Up {"(  "}
                {")"}
              </Text>
              <Text style={styles.checkItem}>
                Refill {"(  "}
                {")"}
              </Text>
              <Text style={styles.checkItem}>
                Walk In {"(  "}
                {")"}
              </Text>
              <Text style={styles.checkItem}>
                Referral {"(  "}
                {")"}
              </Text>
            </View>
          </View>
          <View style={styles.cardStyle}>
            <Text style={styles.title}>
              Print/Fill in clear letters or Emboss Card:
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Insurance Name: </Text>
              <Text style={styles.s1textvalue}>
                {`${patinetInfo?.patient_firstname || ""} ${
                  patinetInfo?.patient_familyname
                }`}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>National ID / Iqama : </Text>
              <Text style={styles.s1textvalue}>
                {patinetInfo?.patient_nationalid}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>ID. Card No. : </Text>
              <Text style={styles.s1textvalue}>
                {coveragePersonal?.memberid}
              </Text>
            </Text>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Sex : </Text>
                <Text style={styles.s1textvalue}>{patinetInfo?.gender}</Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>DOB : </Text>
                <Text style={styles.s1textvalue}>
                  {patinetInfo?.patient_dob}
                </Text>
              </Text>
            </View>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Policy Holder : </Text>
              <Text style={styles.s1textvalue}>
                {patinetInfo?.sponsor_name}
              </Text>
            </Text>

            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Policy No. : </Text>
                <Text style={styles.s1textvalue}>
                  {patinetInfo?.sponsor_no}
                </Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Expiry Date : </Text>
                <Text style={styles.s1textvalue}>
                  {payerPersonal?.serviceto}
                </Text>
              </Text>
            </View>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Class : </Text>
                <Text style={styles.s1textvalue}>
                  {coveragePersonal?.class}
                </Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Status : </Text>
                <Text style={styles.s1textvalue}>
                  {printData?.eligibility_status || "-"}
                </Text>
              </Text>
            </View>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Eligibility Ref. NO : </Text>
              <Text style={styles.s1textvalue}>
                {payerPersonal?.reference_no || "-"}
              </Text>
            </Text>
          </View>
        </View>

        <View style={styles.card}>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Consult. Free Max Limit : </Text>
              <Text
                style={styles.s1textvalue}
              >{`${coveragePersonal?.maxlimit} SAR`}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Deductible : </Text>
              <Text
                style={styles.s1textvalue}
              >{`${coveragePersonal?.deductable} %`}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>To be Collected : </Text>
              <Text style={styles.s1textvalue}></Text>
            </Text>
          </View>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Approval Limit : </Text>
              <Text style={styles.s1textvalue}></Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Deductible Desc : </Text>
              <Text style={styles.s1textvalue}></Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}></Text>
              <Text style={styles.s1textvalue}></Text>
            </Text>
          </View>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}></Text>
              <Text style={styles.s1textvalue}></Text>
            </Text>
          </View>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Special Member Info : </Text>
            <Text style={styles.s1textvalue}></Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Special Coverage Info : </Text>
            <Text style={styles.s1textvalue}></Text>
          </Text>
        </View>

        <View style={styles.card}>
          <Text style={styles.title}>
            To be Completed by the Attending PHYSICIAN: Please tick(✓)
          </Text>
          <View style={styles.flexRow}>
            <Text style={styles.checkItem}>Inpatient ( )</Text>
            <Text style={styles.checkItem}>Outpatient ( ✓ )</Text>
            <View style={styles.emergencyCasStyle}>
              <Text style={styles.checkItem}>
                <Text style={styles.dottedLine}>
                  <Text style={styles.s1textLabel}>Emergency Case ( ) </Text>
                  <Text style={styles.s1textvalue}>| Emergency Level:</Text>
                </Text>
              </Text>
              <Text style={styles.checkItem}> 1 ( ) </Text>
              <Text style={styles.checkItem}> 2 ( ) </Text>
              <Text style={styles.checkItem}> 3 ( )</Text>
            </View>
          </View>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>BP: </Text>
              <Text style={styles.s1textvalue}>...../.....</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Pulse: </Text>
              <Text style={styles.s1textvalue}>......bpm</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Temp: </Text>
              <Text style={styles.s1textvalue}>......°C</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Weight: </Text>
              <Text style={styles.s1textvalue}>......Kg</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Height: </Text>
              <Text style={styles.s1textvalue}>......cm</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>R.R: </Text>
              <Text style={styles.s1textvalue}> ......</Text>
            </Text>
          </View>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Duration of illness: </Text>
            <Text style={styles.s1textvalue}> ........(Days)</Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>
              Chief Complaints and Main Symptoms:{" "}
            </Text>
            <Text style={styles.s1textvalue}> {"."?.repeat(150)}</Text>
          </Text>
          <Text>{"."?.repeat(200)}</Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Other Conditions: </Text>
            <Text style={styles.s1textvalue}> {"."?.repeat(150)}</Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Diagnosis: </Text>
            <Text style={styles.s1textvalue}> {"."?.repeat(150)}</Text>
          </Text>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Principle Code: </Text>
              <Text style={styles.s1textvalue}> {"."?.repeat(40)}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>
                2
                <Text style={[styles.superscript, styles.s1textvalue]}>nd</Text>{" "}
                Code:{" "}
              </Text>
              <Text style={styles.s1textvalue}>{".".repeat(40)}</Text>
            </Text>

            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>
                3
                <Text style={[styles.superscript, styles.s1textvalue]}>rd</Text>{" "}
                Code:{" "}
              </Text>
              <Text style={styles.s1textvalue}> {"."?.repeat(40)}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>
                4
                <Text style={[styles.superscript, styles.s1textvalue]}>th</Text>{" "}
                Code:{" "}
              </Text>
              <Text style={styles.s1textvalue}> {"."?.repeat(40)}</Text>
            </Text>
          </View>
          <View style={styles.commentLine} />
          <Text style={styles.title}>Please tick(✓) where appropriate :</Text>
          <View style={styles.flexRow}>
            <Text style={styles.checkItem}>Chronic ( )</Text>
            <Text style={styles.checkItem}>Congenital ( )</Text>
            <Text style={styles.checkItem}>RTA ( )</Text>
            <Text style={styles.checkItem}>Work Related ( )</Text>
            <Text style={styles.checkItem}>Vaccination ( )</Text>
          </View>
          <View style={styles.flexRow}>
            <Text style={styles.checkItem}>Check-up ( )</Text>
            <Text style={styles.checkItem}>Psychiatric ( )</Text>
            <Text style={styles.checkItem}>Infertility ( )</Text>
            <Text style={styles.checkItem}>Pregnancy ( )</Text>
            <Text style={styles.checkItem}>Indicate LMP: ..........</Text>
          </View>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textvalue}>
              {" "}
              Suggestive line(s) of management: Kindly, enumerate the
              recommended investigaions, and/or procedures
            </Text>
            <Text style={styles.s1textLabel}>
              {" "}
              For outpatient approvals only:{" "}
            </Text>
          </Text>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <Text
                style={[styles.tableCell, { borderTop: "0.7px solid #999" }]}
              >
                (Code) Service
              </Text>
              <Text
                style={[
                  styles.tableCell,
                  styles.descriptionCell,
                  { borderTop: "0.7px solid #999" },
                ]}
              >
                Description
              </Text>
              <Text
                style={[styles.tableCell, { borderTop: "0.7px solid #999" }]}
              >
                Req. Qty
              </Text>
              <Text
                style={[styles.tableCell, { borderTop: "0.7px solid #999" }]}
              >
                Discount Amount
              </Text>
              <Text
                style={[
                  styles.tableCell,
                  styles.lastTableCell,
                  { borderTop: "0.7px solid #999" },
                ]}
              >
                Cost
              </Text>
            </View>
            {[0, 1, 2, 3, 4]?.map((_, index) => (
              <View style={styles.tableRow} key={index}>
                <Text style={styles.tableCell}>{"  "}</Text>
                <Text style={[styles.tableCell, styles.descriptionCell]}></Text>
                <Text style={styles.tableCell}></Text>
                <Text style={styles.tableCell}></Text>
                <Text style={[styles.tableCell, styles.lastTableCell]}></Text>
              </View>
            ))}
          </View>
          <View style={[styles.flexRow]}>
            <Text style={styles.s1textLabel}>
              Providers Approval/Coding Staff must review/code the recommended
              service(s) and allocate cost and complete the following:
            </Text>
          </View>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Completed / Coded By: </Text>
              <Text style={styles.s1textvalue}> {"."?.repeat(30)}</Text>
            </Text>

            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Signature: </Text>
              <Text style={styles.s1textvalue}> {"."?.repeat(30)}</Text>
            </Text>

            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Date: </Text>
              <Text style={styles.s1textvalue}>
                {" "}
                {"."?.repeat(15)}/{"."?.repeat(15)}/{"."?.repeat(15)}
              </Text>
            </Text>
          </View>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <Text
                style={[
                  styles.tableCell1,
                  styles.descriptionCell1,
                  { borderTop: "0.7px solid #999" },
                ]}
              >
                Medication Name (Generic Name)
              </Text>

              <Text
                style={[styles.tableCell1, { borderTop: "0.7px solid #999" }]}
              >
                Type
              </Text>
              <Text
                style={[
                  styles.tableCell1,
                  styles.lastTableCell,
                  { borderTop: "0.7px solid #999" },
                ]}
              >
                Quantity
              </Text>
            </View>
            {[0, 1, 2, 3, 4]?.map((_, index) => (
              <View style={styles.tableRow} key={index}>
                <Text
                  style={[styles.tableCell1, styles.descriptionCell1]}
                ></Text>
                <Text style={styles.tableCell1}></Text>
                <Text style={[styles.tableCell1, styles.lastTableCell]}></Text>
              </View>
            ))}
          </View>
          <View style={[styles.flexRow]}>
            <Text style={styles.s1textLabel}>
              In case Management Form (CMF1.0) included
              <View style={[styles.flexRow, { marginRight: 5, marginLeft: 5 }]}>
                <Text style={styles.checkItem}> {"  "}Yes ( )</Text>
                <Text style={styles.checkItem}>{"  "}No ( ✓ )</Text>
              </View>
            </Text>
          </View>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>
                Please Specify possible line of management when applicable:{" "}
              </Text>
              <Text style={styles.s1textLabel}>{"."?.repeat(70)}</Text>
            </Text>
          </View>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Estimated Length od stay: </Text>
              <Text style={styles.s1textLabel}>{"."?.repeat(40)} Days</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>
                Expected data od admission:{" "}
              </Text>
              <Text style={styles.s1textLabel}>{"."?.repeat(40)} Days</Text>
            </Text>
          </View>
        </View>

        <View style={[styles.flexRow]}>
          <View style={styles.cardStyle}>
            <Text style={styles.s1textvalue}>
              I hereby certify that ALL information mentioned are correct and
              that the medical services shown on this form were medically
              indicated and necessary for the management of this case.
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Physician: </Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(70)}</Text>
            </Text>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Signature: </Text>
                <Text style={styles.s1textvalue}>{"."?.repeat(40)}</Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Date: </Text>
                <Text style={styles.s1textvalue}>
                  {"."?.repeat(15)}/{"."?.repeat(15)}/{"."?.repeat(15)}
                </Text>
              </Text>
            </View>
          </View>
          <View style={styles.cardStyle}>
            <Text style={styles.s1textvalue}>
              I hereby certify that ALL statements and information provided
              concerning patient identification and the present illness or
              injury are TRUE.
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>
                Name (and relationship if guardian):{" "}
              </Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(50)}</Text>
            </Text>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Signature(*) </Text>
                <Text style={styles.s1textvalue}></Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Date: </Text>
                <Text style={styles.s1textvalue}>
                  {"."?.repeat(15)}/{"."?.repeat(15)}/{"."?.repeat(15)}
                </Text>
              </Text>
            </View>
          </View>
        </View>
        <View style={styles.card}>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>
                For Insurance Company use Only
              </Text>
              <Text style={styles.s1textvalue}>
                Approved ( ) Not Approved ( )
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Approval No: {"  "}</Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(15)}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Approval validity </Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(20)}</Text>
            </Text>
          </View>
          <Text style={styles.s1textvalue}>
            Comments (include approved days/services if different from the
            requested)
          </Text>
          <Text style={[styles.s1textvalue, { paddingTop: 5 }]}>
            {"."?.repeat(100)}
          </Text>
          <View style={styles.flexRow}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>
                Approved/Disapproved By {"  "}
              </Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(20)}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Signature {"  "}</Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(20)}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Date: </Text>
              <Text style={styles.s1textvalue}>
                {"."?.repeat(15)}/{"."?.repeat(15)}/{"."?.repeat(15)}
              </Text>
            </Text>
          </View>
        </View>
        <Text style={styles.s1textLabel}>
          (*) this is applicable only in case of manual UCAF{" "}
        </Text>

        <Text style={styles.createdBy} fixed>
          {`Printed by: | ${printedName || ""} ${moment().format("lll")}`}
        </Text>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `Page ${pageNumber || ""} of ${totalPages || ""}`
          }
          fixed
        />
      </Page>
    </Document>
  );
};

export default UCAF;
